require("./bootstrap");
import Vue from "vue";
import vSelect from "vue-select";

import EventPricing from "./components/EventPricing.vue";
import Register from "./components/Register.vue";
import Loading from "vue-loading-overlay";
import "vue-select/dist/vue-select.css";
import "vue-loading-overlay/dist/vue-loading.css";

window.axios = axios;

Vue.component("v-select", vSelect);
Vue.component("loading", Loading);

Vue.component("event-pricing", EventPricing);
Vue.component("event-register", Register);

new Vue({
  el: "#register"
});
